// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"d6bdac75","180":"e70f8568","225":"b83f3a09","331":"ddd4b199","409":"8465c74a","416":"43513a34","455":"5011d67f","472":"a5316e14","526":"0295d8a7","573":"19bb2972","591":"2e189266","782":"9f95edf0","799":"1e7d21ca","847":"b5757aac"}[chunkId] + ".chunk.js";
};